import React, { Component } from 'react';
var moment = require('moment-timezone');

class VolPlan extends Component {
  constructor(props) {
    super(props);
    this.unixToNormal = this.unixToNormal.bind(this)
  }


  //date and time boolean ....return type
  unixToNormal(unixTime,date,time){
    return moment.unix(unixTime).tz('GMT+0').format((date && 'llll')||(time && 'HH:mm'))
  }

  diffTimes(t1,t2){
    var a = moment.unix(t1)
    var b = moment.unix(t2)
    var hours =  moment.utc(b-a).format('hh')
    var min =  moment.utc(b-a).format('mm')
    var lessThenOneHour = false
    if (hours==='12' && moment.unix(t1).format('l') === moment.unix(t2).format('l')) {
      lessThenOneHour = true
    }
     return lessThenOneHour ===false ? `${hours}`+'h'+`${min}m` : `${min}m`
  }
    render() {
      const itineraries= this.props.itineraries 
        return (
            <>
            {itineraries && itineraries.map(itinerarie=>{
              return <>
                   <div className="plan__vol d-flex align-items-center">
                      <div className="plan__volIcon__cont">
                        <img className="plan__volIcon" src="/imgs/vols/planeIcon.svg" alt="" />
                      </div>
                      <div className="plan__volInfos">
                        <h4 className="plan__volName">{typeof itinerarie.operating_airline !=='undefined' && itinerarie.operating_airline.name ||typeof itinerarie.airline !=='undefined' && itinerarie.airline.name || 'unkonwn' + ' Airways'} (Vol n° {itinerarie.flight_no})</h4>
                        <h6 className="opacity__items">{this.diffTimes(itinerarie.dtime_unix,itinerarie.atime_unix)} de vol</h6>
                      </div>
                  
                    </div>
                    <div className="plan__volDetails d-flex align-items-center mt-1 mt-md-3">
                      <img className="ml-3 mr-4 plan__timeline" src="/imgs/vols/Groupe_670.svg" alt="" />
                      <div className="plan__departArv__cont">
                        <div className="plan__departArv ">
                          <div className="plan__depart d-flex mb-1 mb-md-4">
                            <div className="plan__departArv__time mr-4">
                              <h4 className="plan__volPlaces">{this.unixToNormal(itinerarie.dtime_unix,false,true)}</h4>
                              <h6 className="opacity__items">{this.unixToNormal(itinerarie.dtime_unix,true,false)}</h6>
                            </div>
                            <div className="plan__departArv__place ml-4">
                              <h4 className="plan__volPlaces">{itinerarie.src_name}</h4>
                              <p className="opacity__items">{itinerarie.dst_station}, {itinerarie.dst}</p>
                            </div>
                          </div>
                          
                          <div className="plan__arv d-flex mt-1 mt-md-4">
                            <div className="plan__departArv__time mr-4">
                              <h4 className="plan__volPlaces">{this.unixToNormal(itinerarie.atime_unix,false,true)}</h4>
                              <h6 className="opacity__items">{this.unixToNormal(itinerarie.atime_unix,true,false)}</h6>
                            </div>
                            <div className="plan__departArv__place ml-4">
                              <h4 className="plan__volPlaces">{itinerarie.dst_name}</h4>
                              <p className="opacity__items">{itinerarie.src_station}, {itinerarie.src}</p>
                            </div>
                          </div>
                            
                        </div>
                      </div>
                    </div>
              </>
            })}

            </>
        );
    }
}

export default VolPlan;
